import axios from 'axios';
import { buildApiUrl } from '../../../config/api';
import authService from '../../authService';
import { ERROR_MESSAGES } from '../config/qbConstants';
import { handlePDFError } from '../api/errorHandler';

// Download invoice PDF from QuickBooks
export const downloadInvoicePDF = async (franchiseeId, qbInvoiceId) => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error(ERROR_MESSAGES.AUTH_REQUIRED);
    }

    const response = await axios.get(
      buildApiUrl(`quickbooks/invoices/${franchiseeId}/${qbInvoiceId}/pdf`),
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/pdf'
        },
        responseType: 'blob'
      }
    );

    // Create blob URL and trigger download
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `invoice-${qbInvoiceId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    handlePDFError(error);
  }
};